module.exports = __webpack_public_path__ + "img/finding-2.84071a5e.png";